enum ReportIndicators {
  VERY_GOOD = "4",
  GOOD = "3",
  MILD = "2",
  BAD = "1",
  VERY_BAD = "0",
}

export { ReportIndicators };
